module.exports = __webpack_public_path__ + "img/default-profile.4fcfa001.svg";